<script setup lang="ts">
import bus from '@/bus'

let def = defineProps({
  backText: {
    type: Array<any>,
    default: []
  }
});
function openIframe(itemData: any) {
  let url = itemData.iframeUrl || itemData.url2||itemData.url;
  if (url) {
    bus.emit('openCompositionIframe', url);
  }


}

</script>

<template>
  <div class="mess">
    <div class="mess-ctr">
      <div class="avatar">
        <img class="rounded-circle" src="https://static.yipigai.cn/avatar84.png" alt="avatar">
      </div>
      <div class="cro">
        <div class="cro_left_top"></div>
      </div>
      <div class="text-ctr" >
        <div class="upimg-tip">
          <p>以下是<span class="nianji">{{ backText[0].graden ? backText[0].graden : '' }}</span>批改结果</p>
        </div>
        <div class="correct-ctr">
          <div v-for="(item, index) in backText" :key="item.id" class="compositionItem"
               @click="openIframe(item)">
            <ZwItem :itemData="item"></ZwItem>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<style scoped>
.correct-ctr {
  margin: 0.08rem 0;

}
.nianji{
  color: #59ADEC;
}
.compositionItem {
  max-width: 100%;
  border-radius: 8px;
  min-width: 253px;
  box-sizing: border-box;
  margin-bottom: 4px;
  height: 6px;
  background: #F7F8FA;
}

.mess {
  padding: 0 0 16px 0;
  max-width: 95%;
  -webkit-animation: msgLeft .5s ease-in-out;
  animation: msgLeft .5s ease-in-out;
}


.mess-ctr {
  display: flex;
  width: 100%;
  position: relative;
  overflow: hidden;
}

.rounded-circle {
  display: block;
}

.avatar {
  min-width: 35px;
  min-height: 35px;
  border-radius: 30px;
  overflow: hidden;

  height: 35px;
  width: 35px;
  flex-shrink: 0;
}


.text-ctr {
  background-color: #fff;
  padding: 10px 12px;
  /* max-width: calc(100% - 35px); */
  border-radius: 0 20px 20px 20px;
  font-weight: normal;
  line-height: 24px;
  box-sizing: border-box;
  /* margin-left: 6px; */
  min-width: 0;
  overflow: hidden;
}</style>
